<template>
  <!-- system 标准列表：对齐 police-record/index.vue；上方统计区为业务扩展 -->
  <div>
    <!-- 统计卡片 -->
    <div class="stat-cards">
      <div class="stat-card">
        <div class="stat-title">今日入库数量</div>
        <div class="stat-value text-success">{{ stats.todayIn }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-title">今日出库数量</div>
        <div class="stat-value text-warning">{{ stats.todayOut }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-title">库存总余额</div>
        <div class="stat-value">{{ stats.balance }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-title">库存变动累计</div>
        <div class="stat-value">{{ stats.changeSum }}</div>
      </div>
    </div>

    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @before-open="beforeOpen"
    >
      <template slot="menu" slot-scope="{ row, index }">
        <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
        <el-button type="text" size="small" @click="printRecord(row)">打印</el-button>
      </template>
      <template slot="recordType" slot-scope="{ row }">
        <el-tag :type="row.recordType === 'IN' ? 'success' : 'warning'" size="mini">
          {{ row.recordType === 'IN' ? '入库' : '出库' }}
        </el-tag>
      </template>
      <template slot="changeQty" slot-scope="{ row }">
        <span :class="row.recordType === 'IN' ? 'text-success' : 'text-warning'">
          {{ formatChange(row.changeQty) }}
        </span>
      </template>
    </avue-crud>

    <record-detail-dialog
      :visible.sync="detailVisible"
      :detail="detailData"
      :loading="detailLoading"
    />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, getDetail } from "./api";
import RecordDetailDialog from "./components/RecordDetailDialog.vue";

export default {
  name: "system-parts-record",
  mixins: [crudMixins],
  components: { RecordDetailDialog },
  data() {
    return {
      apiConfig: { getList },
      detailVisible: false,
      detailLoading: false,
      detailData: {},
      stats: {
        todayIn: 0,
        todayOut: 0,
        balance: 0,
        changeSum: 0,
      },
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        stripe: true,
        menuWidth: 180,
        column: [
          {
            label: "时间范围",
            prop: "timeRange",
            type: "daterange",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            search: true,
            hide: true,
            span: 8,
            searchSpan: 6,
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: "流水号",
            prop: "flowNo",
            fixed: "left",
          },
          {
            label: "操作时间",
            prop: "operationTime",
          },
          {
            label: "操作类型",
            prop: "operationType",
            search: true,
            type: "select",
            span: 8,
            dicData: [
              { label: "全部", value: "" },
              { label: "采购入库", value: "purchase" },
              { label: "调拨入库", value: "transfer_in" },
              { label: "退货入库", value: "return" },
              { label: "盘盈入库", value: "inventory_gain" },
              { label: "领用出库", value: "use" },
              { label: "调拨出库", value: "transfer_out" },
              { label: "报废出库", value: "scrap" },
              { label: "盘亏出库", value: "inventory_loss" },
            ],
          },
          // {
          //   label: "配件信息",
          //   prop: "partName",
          //   search: true,
          //   hide: true,
          //   span: 8,
          // },

          // {
          //   label: "仓库/区域",
          //   prop: "warehouse",
          //   search: true,
          //   hide: true,
          //   span: 8,
          // },
          {
            label: "操作类型",
            prop: "recordType",
            search: false,
            hide: true,
            type: "select",
            slot: true,
            dicData: [
              { label: "全部", value: "" },
              { label: "入库", value: "IN" },
              { label: "出库", value: "OUT" },
            ],
          },


          {
            label: "关联工单",
            prop: "batchNo",
            search: true,
            hide: true,
            span: 8,
          },
          // {
          //   label: "领用人",
          //   prop: "operatorName",
          //   search: true,
          //   hide: true,
          //   span: 8,
          // },


          {
            label: "配件信息",
            prop: "partName",
            formatter: (row) => {
              const code = row.partCode || "";
              return code ? `${row.partName || "-"} / ${code}` : (row.partName || "-");
            },
          },
          {
            label: "变动数量",
            prop: "changeQty",
            slot: true,
          },
          {
            label: "操作后库存",
            prop: "afterStock",
          },
          {
            label: "操作人",
            prop: "operatorName",
            search: true,
          },
        ],
      },
    };
  },
  methods: {
    formatChange(val) {
      if (val === null || val === undefined || val === "") return "-";
      if (Number(val) > 0) return `+${val}`;
      return `${val}`;
    },
    async openDetail(row) {
      if (!row.id) {
        this.$message.warning("未找到记录ID");
        return;
      }
      this.detailVisible = true;
      this.detailLoading = true;
      try {
        const res = await getDetail(row.id);
        this.detailData = (res.data && res.data.data) || {};
      } catch (e) {
        this.detailData = {};
      } finally {
        this.detailLoading = false;
      }
    },
    printRecord(row) {
      const code = row.flowNo || "";
      this.$message.info(code ? `打印：${code}` : "打印功能待接入");
    },
    // 覆盖 searchChange 以保留 mixin 逻辑
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    // 在 onLoad 后可计算统计数据
    afterSearch() {
      // 简单根据当前页数据统计（无接口时示意）
      const list = this.data || [];
      this.stats.todayIn = list.filter(i => i.recordType === "IN").length;
      this.stats.todayOut = list.filter(i => i.recordType === "OUT").length;
      this.stats.changeSum = list.reduce((sum, i) => sum + (Number(i.changeQty) || 0), 0);
    },
  },
};
</script>

<style scoped lang="scss">
.stat-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}
.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.stat-title {
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}
.stat-value {
  font-size: 18px;
  font-weight: 700;
}
.text-success {
  color: #67c23a;
}
.text-warning {
  color: #e6a23c;
}
</style>




